import { render } from "./LiveAlbumPage.vue?vue&type=template&id=4f66c340&scoped=true"
import script from "./LiveAlbumPage.vue?vue&type=script&lang=js"
export * from "./LiveAlbumPage.vue?vue&type=script&lang=js"

import "./LiveAlbumPage.vue?vue&type=style&index=0&id=4f66c340&scoped=true&lang=css"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f66c340"]])

export default __exports__